import type { ReploPartialElement } from "schemas/generated/element";

import {
  createElement as createElementReduxAction,
  setElementsLoading,
} from "@v1/reducers/core-reducer";
import { useEditorDispatch } from "@v1/store/store";
import { elementRouter, elementUtils } from "@v2/trpc/routes/element";
import { projectUtils } from "@v2/trpc/routes/project";

export const useCreateElementMutation = () => {
  const dispatch = useEditorDispatch();
  const { mutateAsync: createElementMutation, isPending: isLoading } =
    elementRouter.create.useMutation({
      onMutate: () => {
        dispatch(setElementsLoading(true));
      },
      onSuccess: ({ element }) => {
        if (element) {
          dispatch(createElementReduxAction({ element }));
        }
      },
      onSettled: () => {
        dispatch(setElementsLoading(false));
      },
    });

  const createElement = async (element: ReploPartialElement) => {
    const result = await createElementMutation({ element });

    // Wait for cache invalidations to complete if element was created successfully
    if (result.element) {
      await Promise.all([
        projectUtils.listWithStats.invalidate(),
        elementUtils.listAllElementsMetadata.invalidate(),
      ]);
    }

    return result;
  };

  return { createElement, isLoading };
};
